/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompetenceTemplate,
    CompetenceTemplateFromJSON,
    CompetenceTemplateFromJSONTyped,
    CompetenceTemplateToJSON,
} from './CompetenceTemplate';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface AssociatedResultTemplate
 */
export interface AssociatedResultTemplate {
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplate
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssociatedResultTemplate
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssociatedResultTemplate
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplate
     */
    competenceTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplate
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof AssociatedResultTemplate
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {CompetenceTemplate}
     * @memberof AssociatedResultTemplate
     */
    competenceTemplate?: CompetenceTemplate;
}

export function AssociatedResultTemplateFromJSON(json: any): AssociatedResultTemplate {
    return AssociatedResultTemplateFromJSONTyped(json, false);
}

export function AssociatedResultTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssociatedResultTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'competenceTemplateId': !exists(json, 'competenceTemplateId') ? undefined : json['competenceTemplateId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'competenceTemplate': !exists(json, 'competenceTemplate') ? undefined : CompetenceTemplateFromJSON(json['competenceTemplate']),
    };
}

export function AssociatedResultTemplateToJSON(value?: AssociatedResultTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'competenceTemplateId': value.competenceTemplateId,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'competenceTemplate': CompetenceTemplateToJSON(value.competenceTemplate),
    };
}

